import React from 'react'
import _ from 'lodash'
import moment from 'moment'
import {FlashMessages} from '../widgets/flashmessages.component'
import QuickChat from '../widgets/chat/quickchat.container'
import classNames from 'classnames'

export class DetailsLegInfo extends React.Component {
    constructor(props) {
        super(props)

        _.bindAll(this,
    	'formatDate'
        )
    }

 	formatDate() {
	 	if (this.props.arrivalDate) {
	 		let start = this.props.leg.getIn(['properties', 'start'])
	 		let end = this.props.leg.getIn(['properties', 'end'])
	 		// if end - start > 1 show end date
	 		if (Math.ceil(end - start) > 1) {
	 			return (
    <div className="itin-date">
        {this.props.arrivalDate.add(start, 'days').format('MMM DD, YYYY')} - {this.props.arrivalDate.add(Math.ceil(end - start - 1), 'days').format('MMM DD, YYYY')}
    </div>
			 	)
	 		} else {
			 	return (
    <div className="itin-date">
        {this.props.arrivalDate.add(start, 'days').format('MMM DD, YYYY')}

    </div>
			 	)
			 }
		 }
	 }

 	updateDetailSection(section) {
	    this.props.updateDetailSections(this.props.leg, section, this.props.availableDetailSubSections.OVERVIEW)
    }

    render() {
        let navClasses = (nav) => {      
            return classNames(
                'details-menu-block',
                {active: this.props.detailSection === nav}
            )
        }

        return (
            <div className="view-area">
                <div className="view-left-col"/>
                <div className="view-center">
                    <div className="details-menu">
                        <FlashMessages/>
                        <div className={navClasses(this.props.availableDetailSections.DESTINATION)} onClick={() => this.updateDetailSection(this.props.availableDetailSections.DESTINATION)}>
                            <i className="icon-location"/>
                            <span>{this.props.leg.getIn(['destination', 'title'])}</span>
                        </div>	
                        <div className={navClasses(this.props.availableDetailSections.ACCOMMODATIONS)} onClick={() => this.updateDetailSection(this.props.availableDetailSections.ACCOMMODATIONS)}>
                            <i className="icon-hotel"/>
                            <span>ACCOMMODATIONS</span>
                        </div>
                        <div className={navClasses(this.props.availableDetailSections.ACTIVITIES)} onClick={() => this.updateDetailSection(this.props.availableDetailSections.ACTIVITIES)}>
                            <i className="icon-bicycle"/>
                            <span>ACTIVITIES</span>
                        </div>
                        <div className={navClasses(this.props.availableDetailSections.TRAVEL)} onClick={() => this.updateDetailSection(this.props.availableDetailSections.TRAVEL)}>
                            <i className="icon-plane_right"/>
                            <span>TRANSPORTATION</span>
                        </div>	
                    </div>
                </div>
                <div className="view-right-col"/>
            </div>
        )
    }
}


// <div className="leg-snippet-block">
// <FlashMessages />
	  //     <div className="row">
	  //     	{/*
	  //     	<div className="col-sm-1 leg-snippet-arrow">
	  //         <i className="icon-arrow_left_b" aria-hidden="true"></i>
	  //       </div>
	  //   	*/}
	  //       <div className="itinerary-item-header leg-snippet-container">						
// 			{/*<div className="itin-body">
// 				<h1 onClick={() => this.props.onShowDestination(this.props.leg.get('destination'))}>{this.props.leg.getIn(['destination','title'])}</h1>
// 				{this.formatDate()}
// 			</div>*/}
// 			<div className="itin-body-snippet">
// 				{/*<div className={navClasses(null)} onClick={() => this.props.onShowDestination(this.props.leg.get('destination'))}>*/}
// 				<div className={navClasses(this.props.availableDetailSections.DESTINATION)} onClick={() => this.updateDetailSection(this.props.availableDetailSections.DESTINATION)}>
// 					<i className="icon-location_a"></i>
// 					<span>{this.props.leg.getIn(['destination','title'])}</span>
// 				</div>	
// 				{/*<div className={navClasses(this.props.availableDetailSections.OVERVIEW)} onClick={() => this.updateDetailSection(this.props.availableDetailSections.OVERVIEW)}>
// 					<i className="icon-itinerary"></i>
// 					<span>OVERVIEW</span>
// 				</div>*/}
// 				<div className={navClasses(this.props.availableDetailSections.ACCOMMODATIONS)} onClick={() => this.updateDetailSection(this.props.availableDetailSections.ACCOMMODATIONS)}>
// 					<i className="icon-accom"></i>
// 					<span>ACCOMMODATIONS</span>
// 				</div>
// 				<div className={navClasses(this.props.availableDetailSections.ACTIVITIES)} onClick={() => this.updateDetailSection(this.props.availableDetailSections.ACTIVITIES)}>
// 					<i className="icon-bike"></i>
// 					<span>ACTIVITIES</span>
// 				</div>
// 				<div className={navClasses(this.props.availableDetailSections.TRAVEL)} onClick={() => this.updateDetailSection(this.props.availableDetailSections.TRAVEL)}>
// 					<i className="icon-plane"></i>
// 					<span>TRANSPORTATION</span>
// 				</div>						
// 			</div>	
// 			{/*<div className="itin-tools">
// 				<i className="icon-reservation"></i>
// 				<QuickChat {...this.props} targetItem={this.props.leg.getIn(['destination'])} targetItemType='destination'/>
//         <i className="icon-delete"></i>
// 			</div>*/}
// 		</div>


	  //       {/*
	  //       <div className="col-sm-1 leg-snippet-arrow">
	  //       	<i className="icon-arrow_right_b" aria-hidden="true"></i>
	  //       </div>
		 //    */}
	  //     </div>
// </div>